import React, { useContext } from 'react';
import style from './style';
import i18next from 'i18next';
import EAColorIcon from '../../../../components/common/EAColorIcon';
import EAIcon from '../../../../components/common/EAIcon';
import moment from 'moment';
import { Context } from '../../../../states/Store';
import ROUTES from '../../../../config/Routes';
import ArchivedInfos from '../../ArchivedInfos';

const Informations = ({ context, tp }) => {
  const { classes } = style();
  const [state,] = useContext(Context);

  const getExpirationDate = (date) => {
    const m = moment(date);
    return m.isValid()
      ? m.format('DD/MM/YYYY')
      : i18next.t('context.dataTable.noExpirationDate');
  };


  const expDateInfos = () => {
    return (
      <div className={classes.expirationDateWrapper}>
        <div className={classes.label}>
          {i18next.t('context.contextDetail.expirationDate')}
        </div>
        <div className={classes.expirationDate}>
          <EAColorIcon icon={'/context/calendar'} />
          <div className={classes.expirationDateText}>
            {getExpirationDate(tp.expirationDate)}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.titleContainer}>
          <div className={classes.headerIcon}>
            <img
              src={process.env.PUBLIC_URL + '/img/icons/context/domain_menu.svg'}
              alt="back"
            />
          </div>
          <div className={classes.titleWrapper}>
            <div className={classes.infoWrapper}>
              <div className={classes.title}>{tp.name}</div>
              <EAIcon
                onClick={() => {
                  window.open(
                    `/${state.account.id}/${ROUTES.THIRDPARTIES}/${tp.compteFoId}`,
                    '_blank'
                  );
                }}
                className={classes.goToModelIcon}
                icon={'context/goToModel'}
              />
            </div>
          </div>
          {!tp.isArchived && expDateInfos()}
        </div>
        {tp.isArchived &&  <ArchivedInfos
          expirationDate={tp.expirationDate}
          updatedBy={tp.updatedBy}
          motif={tp.motif}
          label={i18next.t('context.ficheContext.archivedLabelTiers')}
        /> }
        <div className={classes.divider}></div>
      </div>
    </div>
  );
};

export default Informations;
